module.exports = __webpack_public_path__ + "img/2.aef15dc9.png";